/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onLockDeck = /* GraphQL */ `subscription OnLockDeck {
  onLockDeck {
    deck_id
    page_name
    locked_by
    locked_at
    lock_expiry
    lock_scope
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnLockDeckSubscriptionVariables,
  APITypes.OnLockDeckSubscription
>;
export const onReleaseDeckLock = /* GraphQL */ `subscription OnReleaseDeckLock {
  onReleaseDeckLock {
    deck_id
    page_name
    locked_by
    locked_at
    lock_expiry
    lock_scope
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnReleaseDeckLockSubscriptionVariables,
  APITypes.OnReleaseDeckLockSubscription
>;
export const onLockPage = /* GraphQL */ `subscription OnLockPage {
  onLockPage {
    deck_id
    page_name
    locked_by
    locked_at
    lock_expiry
    lock_scope
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnLockPageSubscriptionVariables,
  APITypes.OnLockPageSubscription
>;
export const onReleasePageLock = /* GraphQL */ `subscription OnReleasePageLock {
  onReleasePageLock {
    deck_id
    page_name
    locked_by
    locked_at
    lock_expiry
    lock_scope
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnReleasePageLockSubscriptionVariables,
  APITypes.OnReleasePageLockSubscription
>;
export const onUpdateDeck = /* GraphQL */ `subscription OnUpdateDeck($publish_status: PublishStatus) {
  onUpdateDeck(publish_status: $publish_status) {
    pk
    sk
    deckGSI_pk
    deckGSI_sk
    deck_name
    created_date
    last_updated_date
    created_by
    last_updated_by
    locked_by
    locked_at
    lock_expiry
    publish_status
    publish_user
    publish_deck_cycle
    has_active_system_run
    last_publish_date
    publish_timestamp
    deck_cycle
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDeckSubscriptionVariables,
  APITypes.OnUpdateDeckSubscription
>;
export const onUpdateKPIVariant = /* GraphQL */ `subscription OnUpdateKPIVariant($page_ids: [String]) {
  onUpdateKPIVariant(page_ids: $page_ids) {
    pk
    sk
    kpi_variant_id
    variant_name
    variant_overrides {
      account_hierarchy
      account
      location_hierarchy
      location
      project_hierarchy
      project
      company_hierarchy
      company
      product_hierarchy
      product
      revgp_hierarchy
      revgp
      datasource_hierarchy
      datasource
      channel_hierarchy
      channel
      costcenter_hierarchy
      costcenter
      costtype
      costpool
      __typename
    }
    kpi_type
    root_kpi_id
    created_date
    last_updated_date
    created_by
    last_updated_by
    affected_page_ids
    updated_decklines {
      pk
      sk
      page_name
      kpi_id
      kpi_name
      kpi_formula
      serial_no
      is_code_or_description
      is_format_bold
      is_format_italics
      is_format_underline
      format_text_color
      format_cell_color
      format_cell_default
      blankline_type
      is_format_borderline
      footnotes
      subtotal_formula
      subtotal_parent
      is_calculated_kpi
      deckline_drivers {
        account_hierarchy
        account
        location_hierarchy
        location
        project_hierarchy
        project
        company_hierarchy
        company
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costcenter_hierarchy
        costcenter
        costtype
        costpool
        __typename
      }
      is_exception
      page_section
      column_template
      adjcalcflag
      exceptioncalculatedkpiflag
      bordertopflag
      borderrightflag
      borderbottomflag
      borderleftflag
      borderweightflag
      textunderlineflag
      denominator_kpi_id_for_pct
      denominator_kpi_id_drivers {
        account_hierarchy
        account
        location_hierarchy
        location
        project_hierarchy
        project
        company_hierarchy
        company
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costcenter_hierarchy
        costcenter
        costtype
        costpool
        __typename
      }
      denominator_is_calculated_kpi
      denominator_kpi_formula
      root_kpi_id
      kpi_variant_id
      display_name
      denominator_kpi_variant_id
      kpi_name_indent_level
      fxinclflag
      calcdivisionflag
      bps_override_flag
      comments {
        commentId
        user
        commentDesc
        timestamp
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateKPIVariantSubscriptionVariables,
  APITypes.OnUpdateKPIVariantSubscription
>;
export const onDeleteKPIVariant = /* GraphQL */ `subscription OnDeleteKPIVariant($page_ids: [String]) {
  onDeleteKPIVariant(page_ids: $page_ids) {
    kpi_variant_id
    root_kpi_id
    root_kpi_auto_deleted
    affected_page_ids
    deleted_decklines {
      pk
      sk
      page_name
      kpi_id
      kpi_name
      kpi_formula
      serial_no
      is_code_or_description
      is_format_bold
      is_format_italics
      is_format_underline
      format_text_color
      format_cell_color
      format_cell_default
      blankline_type
      is_format_borderline
      footnotes
      subtotal_formula
      subtotal_parent
      is_calculated_kpi
      deckline_drivers {
        account_hierarchy
        account
        location_hierarchy
        location
        project_hierarchy
        project
        company_hierarchy
        company
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costcenter_hierarchy
        costcenter
        costtype
        costpool
        __typename
      }
      is_exception
      page_section
      column_template
      adjcalcflag
      exceptioncalculatedkpiflag
      bordertopflag
      borderrightflag
      borderbottomflag
      borderleftflag
      borderweightflag
      textunderlineflag
      denominator_kpi_id_for_pct
      denominator_kpi_id_drivers {
        account_hierarchy
        account
        location_hierarchy
        location
        project_hierarchy
        project
        company_hierarchy
        company
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costcenter_hierarchy
        costcenter
        costtype
        costpool
        __typename
      }
      denominator_is_calculated_kpi
      denominator_kpi_formula
      root_kpi_id
      kpi_variant_id
      display_name
      denominator_kpi_variant_id
      kpi_name_indent_level
      fxinclflag
      calcdivisionflag
      bps_override_flag
      comments {
        commentId
        user
        commentDesc
        timestamp
        __typename
      }
      __typename
    }
    reordered_decklines {
      pk
      sk
      page_name
      kpi_id
      kpi_name
      kpi_formula
      serial_no
      is_code_or_description
      is_format_bold
      is_format_italics
      is_format_underline
      format_text_color
      format_cell_color
      format_cell_default
      blankline_type
      is_format_borderline
      footnotes
      subtotal_formula
      subtotal_parent
      is_calculated_kpi
      deckline_drivers {
        account_hierarchy
        account
        location_hierarchy
        location
        project_hierarchy
        project
        company_hierarchy
        company
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costcenter_hierarchy
        costcenter
        costtype
        costpool
        __typename
      }
      is_exception
      page_section
      column_template
      adjcalcflag
      exceptioncalculatedkpiflag
      bordertopflag
      borderrightflag
      borderbottomflag
      borderleftflag
      borderweightflag
      textunderlineflag
      denominator_kpi_id_for_pct
      denominator_kpi_id_drivers {
        account_hierarchy
        account
        location_hierarchy
        location
        project_hierarchy
        project
        company_hierarchy
        company
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costcenter_hierarchy
        costcenter
        costtype
        costpool
        __typename
      }
      denominator_is_calculated_kpi
      denominator_kpi_formula
      root_kpi_id
      kpi_variant_id
      display_name
      denominator_kpi_variant_id
      kpi_name_indent_level
      fxinclflag
      calcdivisionflag
      bps_override_flag
      comments {
        commentId
        user
        commentDesc
        timestamp
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteKPIVariantSubscriptionVariables,
  APITypes.OnDeleteKPIVariantSubscription
>;
export const onUpdateRootKPI = /* GraphQL */ `subscription OnUpdateRootKPI {
  onUpdateRootKPI {
    pk
    sk
    root_kpi_id
    root_kpi_name
    kpi_type
    variants {
      pk
      sk
      kpi_variant_id
      variant_name
      variant_overrides {
        account_hierarchy
        account
        location_hierarchy
        location
        project_hierarchy
        project
        company_hierarchy
        company
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costcenter_hierarchy
        costcenter
        costtype
        costpool
        __typename
      }
      kpi_type
      root_kpi_id
      created_date
      last_updated_date
      created_by
      last_updated_by
      __typename
    }
    created_date
    created_by
    last_updated_date
    last_updated_by
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRootKPISubscriptionVariables,
  APITypes.OnUpdateRootKPISubscription
>;
